import React from 'react';
import { Main } from '@blueprints2/core';
import './AppMain.css';

const AppMain = (props: any) => {
	return (
		<>
			<Main className='px-10 pt-6 pb-6' style={{ minHeight: '25rem' }}>
				{props.children}
			</Main>
		</>
	);
};

export default AppMain;
